import Vip from './index';
import VipLevel from './Level';
import VipRate from './Rate';
import VipApproval from './Approval';
import VipRechargeTrialCardApproval from './RechargeTrialCardApproval';
import VipMigrationTrialCardApproval from './MigrationTrialCardApproval';
import VipUser from './User';
import VipWhitelist from './Whitelist';

export default {
  path: '/home/vip',
  component: Vip,
  meta: { titie: 'VIP管理' },
  children: [
    {
      path: '/home/vip/level',
      meta: { titie: 'VIP等级管理' },
      component: VipLevel,
    },
    {
      path: '/home/vip/rate',
      meta: { titie: 'VIP费率管理' },
      component: VipRate,
    },
    {
      path: '/home/vip/approval',
      meta: { titie: 'VIP达标审批' },
      component: VipApproval,
    },
    {
      path: '/home/vip/recharge-trial-card-approval',
      meta: { titie: 'VIP体验卡审批' },
      component: VipRechargeTrialCardApproval,
    },
    {
      path: '/home/vip/migration-trial-card-approval',
      meta: { titie: 'VIP迁移体验卡审批' },
      component: VipMigrationTrialCardApproval,
    },
    {
      path: '/home/vip/whitelist',
      meta: { titie: 'VIP白名单用户' },
      component: VipWhitelist,
    },
    {
      path: '/home/vip/user',
      meta: { titie: 'VIP用户管理' },
      component: VipUser,
    },
  ],
};
